function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 24,
  height: 24
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.75947,19.0303H4.9678V4.24242A.24259.24259,0,0,0,4.72538,4H4.24053a.24259.24259,0,0,0-.24242.24242V19.75758A.24259.24259,0,0,0,4.24053,20H19.75947a.24259.24259,0,0,0,.24242-.24242v-.48485A.24259.24259,0,0,0,19.75947,19.0303Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.96686,16.08712A1.48725,1.48725,0,0,0,9.45265,14.6018a1.471,1.471,0,0,0-.14773-.64489l1.63542-1.43418a1.50848,1.50848,0,0,0,1.57292-.0554l.67708.69129a1.48542,1.48542,0,1,0,2.5786.18087L18.1411,10.5928a1.45968,1.45968,0,0,0,.375.0483,1.48533,1.48533,0,1,0-1.48485-1.48485,1.46657,1.46657,0,0,0,.2983.89157l-2.24338,2.59849a1.49512,1.49512,0,0,0-1.11931-.08l-.86743-.88589a1.45558,1.45558,0,0,0,.06818-.44413,1.48532,1.48532,0,1,0-2.86269.55445l-1.6856,1.4768a1.48521,1.48521,0,1,0-.65246,2.8196Zm0-.9697A.51563.51563,0,1,1,8.483,14.6018.5161.5161,0,0,1,7.96686,15.11742Zm3.715-3.36553a.51563.51563,0,1,1,.5161-.51562A.51609.51609,0,0,1,11.68182,11.75189ZM19.0322,9.15625a.51563.51563,0,1,1-.5161-.5161A.51589.51589,0,0,1,19.0322,9.15625ZM14.429,14.49432a.51587.51587,0,1,1,.51515-.5161A.5164.5164,0,0,1,14.429,14.49432Z"
});

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a1c986ca.svg";
export { ForwardRef as ReactComponent };